export default "__VITE_ASSET__CO4MWo7a__"